import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { IProjectType } from "../../../@types/project/project.type";
import { getProjectById } from "../../../services/api/projects/projectService";
import { Project } from "../Project";
import { includeCustomFieldsfromApi } from "../adapters/projectCustomFields";
import CircularProgress from "@mui/material/CircularProgress";

export const UpdateProject: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [project, setProject] = useState({} as IProjectType);
  const { id } = useParams();
  const navigate = useNavigate();

  async function fetchProjectById() {
    try {
      setLoading(true);

      if (!id) {
        toast.error("ID do projeto não fornecido!");
        navigate("/*");
        return;
      }

      const response = await getProjectById(id);

      if (!response.result) {
        toast.error("Projeto não encontrado!");
        navigate("/*");
        return;
      }

      setProject(includeCustomFieldsfromApi(response.result));
    } catch (error) {
      console.log(error);
      toast.error("Erro ao carregar o Projeto!");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchProjectById();
  }, [id]);

  return (
    <>
      {loading ? (
        <CircularProgress
          size={100}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      ) : (
        <div>
          <Project pageType="update" projectData={project} />
        </div>
      )}
    </>
  );
};
